import { Injectable } from '@angular/core';
import { SingleDepartmentService } from '../../../shared/services/single-department.service';

@Injectable({
  providedIn: 'root',
})
export class PleatPackDepartmentService extends SingleDepartmentService {
  private _departmentId: number;
  set departmentId(value: number) {
    this._departmentId = value;
  }
  get departmentId(): number {
    return this._departmentId;
  }
  readonly NAME = 'Pleat Packs';
  readonly DEPARTMENT_ID = 13;

  defaultRoutes(roles: string[]): boolean {
    if (
      roles.includes('PleatsPacksOperator') ||
      roles.includes('PleatsPacksChief')
    ) {
      this.router.navigate(['sb/pliegues/scheduling']);
    }
    return false;
  }
}
